const getBreakpointWidthFromStyle = (style) => {
  const defaultValue = {
    value: 100,
    unit: "%"
  };
  const width = style == null ? void 0 : style.width;
  const widthUnit = style == null ? void 0 : style.widthUnit;
  if (widthUnit) {
    if (isNaN(+width))
      return defaultValue;
    return {
      value: +width,
      unit: widthUnit
    };
  }
  if (typeof width === "number")
    return {
      value: width,
      unit: "px"
    };
  return defaultValue;
};

export { getBreakpointWidthFromStyle };
